import { jsxs as T, jsx as x } from "react/jsx-runtime";
import { useState as _, useRef as b, useEffect as k } from "react";
import { u as v } from "./index-6a632112.mjs";
import { c as H, C as M } from "./createOptions-4792754a.mjs";
import { s as a } from "./themes-5f0b3c3d.mjs";
import { f as P } from "./fontWeights-a25f8f91.mjs";
import { l as Y } from "./lineHeights-72d3110c.mjs";
const B = v.div`
  height: 100%;
  width: 100%;
  position: relative;
  #axisEle {
    height: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    background: white;
    .apexcharts-legend.apexcharts-align-left {
      visibility: hidden;
    }
  }
`, D = v.div`
  height: 100%;
  width: 100%;
  overflow-x: auto;
  position: relative;

  .apexcharts-yaxistooltip {
    padding: 0 !important;
  }
  .apexcharts-legend.apx-legend-position-top,
  .apexcharts-legend.apx-legend-position-bottom {
    max-height: 100px !important;
  }

  .apexcharts-legend .apexcharts-legend-series {
    display: flex !important;
    align-items: center !important;
    padding: ${a["1x"]};
    gap: 10px;

    .apexcharts-legend-text {
      padding-left: unset;
      margin-left: unset;
    }
  }

  ${({ $vertical: n }) => {
  if (n)
    return `
      .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
        display: inline-flex;
        align-items: flex-start;
        padding: ${a["1x"]};
        padding-left: ${a["2x"]};
        margin: 0 !important;
        width: 100%;
      }
      .legend-item {
        width: 100%;
      }
      .apexcharts-legend-text {
        pointer-events: none;
        display: flex !important;
        /* gap: 10px; */
        justify-content: space-between !important;
        margin-left: 10px !important;
      }
      .apexcharts-legend-text {
        width: 100% !important;
        line-height: ${Y.small};
      }
      .apexcharts-legend-marker {
        top: ${a["1x"]} !important;
      }
      .total-label {
        position: absolute;
        font-weight: ${P.body.semibold};
        left: 0px;
        margin: 0px !important;
        padding-top: ${a["2x"]};
        width: 100%;
      }
      .total-text {
        margin-left: 0px !important;
      }
    `;
}}
`, J = ({
  chartLibElement: n,
  legend: r,
  isCategorical: w = !0,
  colorPallete: W = ["blue"],
  hideLabel: E = !1,
  labelFormatter: C,
  series: o,
  xAxis: j,
  yAxis: A,
  variant: c = "default",
  gridType: q = "yaxis",
  height: i = 350,
  width: e,
  isScroll: d = !0
}) => {
  const O = "light", [s, m] = _(0), t = b(null), h = b(null), f = H({
    legend: r,
    isCategorical: w,
    colorPallete: W,
    hideLabel: E,
    labelFormatter: C,
    xAxis: j,
    yAxis: A,
    type: M.COLUMN,
    variant: c,
    gridType: q,
    series: o,
    mode: O
  }), p = o;
  return k(() => {
    setTimeout(() => {
      if (d && t?.current && h?.current) {
        t?.current.querySelector('div[type="bar"]');
        const R = h?.current, S = t?.current.querySelector("g.apexcharts-yaxis"), u = t?.current.querySelector(
          ".apexcharts-legend.apexcharts-align-left"
        ), l = S?.getBoundingClientRect().width || 50;
        if (l > 50 && (r?.position === "bottom" || r?.position === "top") && u?.setAttribute(
          "style",
          `${u.getAttribute("style")}; inset: auto 0px -5px ${l - 18}px`
        ), R?.setAttribute(
          "style",
          `height: unset; width: ${l + 5}px`
        ), !e) {
          let g = 1;
          o.forEach(($) => {
            $?.data?.length > g && (g = $.data.length);
          });
          const y = g * 50 + l || 0;
          t?.current?.clientWidth > y ? m(t?.current?.clientWidth) : m(y);
        }
      }
    }, 500);
  }, [d, o, e]), /* @__PURE__ */ T(B, { children: [
    /* @__PURE__ */ x(D, { $vertical: r?.orientation === "vertical", ref: t, children: /* @__PURE__ */ x(
      n,
      {
        width: e ? `${e}px` : s || "100%",
        height: i ? `${i}px` : "350px",
        options: f,
        series: p,
        type: "bar"
      },
      `${c}_${p.length}`
    ) }),
    d && /* @__PURE__ */ x("div", { id: "axisEle", ref: h, children: /* @__PURE__ */ x(
      n,
      {
        width: e ? `${e}px` : s || "100%",
        height: i ? `${i}px` : i === 0 ? "auto" : "350px",
        options: f,
        series: p,
        type: "bar"
      },
      `${c}_${p.length}`
    ) })
  ] });
};
export {
  J as ColumnChart
};
